export default __webpack_public_path__ + "images/UBE.437fc14.png";